<template>
    <div id="app"  style="height: 100%;">
        <!--
        <div class="ui left vertical menu sidebar">
            <div class="header item" @click.prevent="showSidebar">
                Menú Principal
                <i class="arrow left icon"></i>
            </div>

            <div class="item">
                <div class="ui transparent icon input">
                    <input id="mainSearch" type="text" placeholder="Buscar..." v-model="buscador">
                    <i class="search icon"></i>
                </div>
            </div>

            <template v-for="menuItem in menu">
                <router-link class="item closeSidebar" :to="menuItem.path"
                             v-if="menuItem.path !== null && (menuItem.visible == true || menuItem.visible == 'true')">{{menuItem.name}}
                </router-link>

                <div class="ui item" v-if="menuItem.path === null && (menuItem.visible == true || menuItem.visible == 'true')">
                    {{menuItem.name}}
                    <div class="menu">
                        <router-link v-for="submenu in menuItem.children" :to="submenu.path"
                                     v-if="submenu.path !== null"
                                     class="item closeSidebar">{{submenu.name}}
                        </router-link>
                    </div>
                </div>
            </template>
        </div>
        <div class="dimmer pusher">
            <router-view/>
        </div>
        -->
        <router-view/>
    </div>
</template>

<script>
  import CoreLangLoader from './lang/LangLoader'

  export default {
    name: 'app',
    data () {
      return {
        buscador: ''
      }
    },
    mounted () {
      /*this.sidebar = jQuery('.ui.sidebar').sidebar({
        context: jQuery('#app'),
        transition: 'overlay',
        mobileTransition: 'overlay'
      })*/
      CoreLangLoader.loadRemoteLangs()
    },
    updated () {
      this.$nextTick(() => {
        //this.sidebar.sidebar('attach events', '.closeSidebar')
      })
    },
    methods: {
      showSidebar: function () {
        //jQuery('.ui.sidebar').sidebar('toggle')
      },
      hideSidebar: function () {
        //jQuery('.ui.sidebar').sidebar('hide')
      }
    },
    computed: {
      userInfo () {
        return this.$store.state.userInfo ? this.$store.state.userInfo : {}
      },
      menu () {
        let uf = this.userInfo
        if (!uf.menu) {
          return []
        }
        if (this.buscador === '') {
          return uf.menu
        }
        let nm = []
        for (let i = 0; i < uf.menu.length; i++) {
          if (uf.menu[i].name.toLowerCase().startsWith(this.buscador.toLowerCase())) {
            nm.push(uf.menu[i])
          }
        }
        return nm
      }
    }
  }
</script>
<style>
    .ui.table td:not(.ignore) {
        padding: 0.3em 0.3em !important;
    }

    .ui.selectable.table tbody tr.selected,
    .ui.table tbody tr.selected {
        background: rgba(0, 0, 0, .2) !important;
        color: rgba(0, 0, 0, .95) !important;
    }

    .ui.table thead th:not(.ignore) {
        padding: .5em .5em !important;
    }

    .impresionPedido, .printBreak {
        page-break-after: always;
    }

    .paddingB3 {
        padding-bottom: 3px !important;
    }

    .paddingT3 {
        padding-top: 3px !important;
    }

    .column.field > label{
        text-transform: uppercase !important;
    }
</style>



// WEBPACK FOOTER //
// src/App.vue